import React from "react";
import { Box, Typography, Slider, Card, CardContent } from "@mui/joy";
import { Percent } from "lucide-react";

interface SiteSetupProps {
    values: Record<string, any>;
    onChange: (key: string, value: any) => void;
}

export default function SiteSetup({ values, onChange }: SiteSetupProps) {
    return (
        <Card variant="soft" sx={{ border: "1px solid", borderColor: "divider" }}>
            <CardContent>
                <Typography level="title-sm" mb={2} startDecorator={<Percent size={18} />}>
                    Material Waste
                </Typography>

                <Box sx={{ px: 0.5 }}>
                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                        <Typography level="body-sm">Waste factor</Typography>
                        <Typography level="title-sm" color="primary">
                            {values.EST_WASTE_FACTOR}%
                        </Typography>
                    </Box>
                    <Slider
                        value={values.EST_WASTE_FACTOR}
                        onChange={(_, val) => onChange("EST_WASTE_FACTOR", val)}
                        step={1}
                        min={5}
                        max={25}
                        marks={[
                            { value: 5, label: "5%" },
                            { value: 25, label: "25%" },
                        ]}
                    />
                    <Typography level="body-xs" color="neutral" sx={{ mt: 1 }}>
                        Applied to field shingle material cost on the contract (Excel waste / C13). Layers, pitch,
                        and story height come from Initial Inspection.
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
}
